import { graphql } from '@/generated/gql';

export const SAVE_APP_CONFIG_MUTATION = graphql(/* GraphQL */ `
  mutation SaveAppConfig($input: appConfig_insert_input!) {
    insert_appConfig_one(
      object: $input
      on_conflict: { constraint: appConfig_userId_key, update_columns: [navDrawerPinned] }
    ) {
      id
      navDrawerPinned
    }
  }
`);
